export const selectRails = (state) => state.rails?.rails || [];
export const selectRailsStatus = (state) => state.rails?.railsStatus;
export const selectRailsError = (state) => state.rails?.railsError;

export const selectSubmitStatus = (state) => state.rails?.submitStatus;
export const selectSubmitError = (state) => state.rails?.submitError;
export const selectSubmitResult = (state) => state.rails?.submitResult;
